import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterModule } from '@angular/router';
import { Observable, take } from 'rxjs';
import { User } from '../../shared/interfaces/user.interfaces';
import { Store } from '@ngrx/store';
import { RootState } from '../../core/stores/store';
import { selectCurrentUser } from '../../core/stores/user/user.selectors';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    RouterModule,
    MatButtonModule
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {

  currentUser$: Observable<User | undefined>;

  constructor(
    private store: Store<RootState>,
    private router: Router
  ) {
    this.currentUser$ = this.store.select(selectCurrentUser)
  }

  ngOnInit(): void {
    this.currentUser$.pipe(take(1)).subscribe(user => {
      if (user) {
        this.router.navigate(['/main'])
      }
    });
  }
}
